import { FavouritesPageModel } from 'models/FavouritesPageModel';
import { Section } from 'components/Section';
import { Grid, Cell } from 'components/Grid';
import { ProductCard } from 'components/Shared/Product';
import { FavouritesListviewProduct } from 'models/FavouritesListviewProduct';
import connect from 'components/Shared/connect';
import styles from '../../styles.scss';
import { rm } from 'utils';
import { isMobile } from 'components/Shared/responsive';
import { LoaderButton } from 'components/Button';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import cn from 'classnames';

interface OwnProps {
  isMobile: boolean;
  baseStyle?: string;
}

interface MergedProps extends FavouritesPageModel {
  isMobile: boolean;
  baseStyle?: string;
}

const MOBILE_WIDTH = 181;
const DESKTOP_WIDTH = 358;
const IMAGE_MARGIN = 2;

const picture = {
  height: DESKTOP_WIDTH + IMAGE_MARGIN,
  width: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const FavouritesPage = ({
  favouritesList,
  basedOnFavourites,
  isMobile,
  baseStyle
}: MergedProps) => {
  const yourFavoritesSubtitle = rm('favouritespage_recommendedtitle');
  const yourFavoritesSubtitleShort = rm('favouritespage_recommendedtitleshort');
  const yourFavoritesTitle = rm('favouritespage_yourfavourites');
  const noFavouritesTitle = rm('favouritespage_nofavouritestitle');
  const noFavouriteSubtitle = rm('favouritespage_nofavouritessubtitle');

  const favouritesContent = favouritesList?.map((product: FavouritesListviewProduct) => (
    <FavouritesProductCard key={product.productId} product={product} isMobile={isMobile} />
  ));
  const basedOnFavouritesContent = basedOnFavourites?.map((product: FavouritesListviewProduct) => (
    <Cell key={product.productId}>
      <ProductCard isCategoryBold {...product} picture={picture} customSizes={sizes} />
    </Cell>
  ));
  return (
    <div className={cn(styles.base, baseStyle)}>
      {favouritesList?.length ? (
        <>
          <Section>
            <h1>{yourFavoritesTitle}</h1>
            <Grid huge="4" desktop="4" tablet="3" phone="2" gutters="extraLarge">
              {favouritesContent}
            </Grid>
          </Section>
          {basedOnFavouritesContent && (
            <Section title={isMobile ? yourFavoritesSubtitleShort : yourFavoritesSubtitle}>
              <Grid huge="4" desktop="4" tablet="3" phone="2" gutters="extraLarge">
                {basedOnFavouritesContent}
              </Grid>
            </Section>
          )}
        </>
      ) : (
        <Section className={styles.noFavourites}>
          <h3>{noFavouritesTitle}</h3>
          <p>{noFavouriteSubtitle}</p>
        </Section>
      )}
    </div>
  );
};
export default connect<MergedProps, OwnProps>(state => {
  return {
    favouritesList: (state.currentPage as FavouritesPageModel).favouritesList,
    basedOnFavourites: (state.currentPage as FavouritesPageModel).basedOnFavourites,
    isMobile: isMobile(state)
  };
})(FavouritesPage);

const FavouritesProductCard = ({
  product,
  isMobile
}: {
  product: FavouritesListviewProduct;
  isMobile: boolean;
}) => {
  const { productId } = product;

  const goToProductText = rm('favouritespage_gotoproduct').toUpperCase();
  const goToProductTextShort = rm('favouritespage_showmore').toUpperCase();
  return (
    <Cell key={productId}>
      <ProductCard isCategoryBold {...product} picture={picture} customSizes={sizes}>
        <div>
          <LoaderButton
            size="medium"
            appearance="quaternary"
            textTransform="uppercase"
            className={styles.linkToProductButton}
            href={product.url}
          >
            {isMobile ? goToProductTextShort : goToProductText}
          </LoaderButton>
        </div>
      </ProductCard>
    </Cell>
  );
};
